module.exports = __webpack_public_path__ + "img/fr_failure_2.591b7750.png";